import { fixedUi } from '@/i18n/fixedUi';
import React, { useRef } from 'react';

export default function TemuRefreshButton({
  onClick,
  loading = false,
  cooldownSeconds = 0,
  disabled = false,
  busyLabel = '查询中…',
  cooldownLabel,
  children = fixedUi("刷新"),
  className = 'temu-btn temu-btn--ghost',
  size,
  type = 'button',
  ...rest
}) {
  const isBusy = Boolean(loading);
  const isCooldown = cooldownSeconds > 0;

  let label = children;
  if (isBusy) {
    label = busyLabel;
  } else if (isCooldown) {
    label = cooldownLabel
      ? cooldownLabel(cooldownSeconds)
      : `${cooldownSeconds}s 后可刷新`;
  }

  const classes = [
    className,
    size === 'sm' ? 'temu-btn--sm' : '',
  ].filter(Boolean).join(' ');

  const lockedRef = useRef(false);
  const onClickRef = useRef(onClick);
  onClickRef.current = onClick;

  const handleClick = async (event) => {
    if (disabled || isBusy || isCooldown || lockedRef.current) return;
    lockedRef.current = true;
    try {
      await onClickRef.current?.(event);
    } finally {
      lockedRef.current = false;
    }
  };

  return (
    <button
      type={type}
      className={classes}
      onClick={handleClick}
      disabled={disabled || isBusy || isCooldown}
      {...rest}
    >
      {label}
    </button>
  );
}
